export const SIGNUP_MODAL_DENSE_MOBILE_FLAG =
	"signup-modal-dense-mobile" as const;

export type SignupModalDenseMobileVariant = "control" | "test";

/**
 * Whether the PostHog flag value is the denser mobile signup modal variant.
 */
export const isSignupModalDenseMobileTest = (
	flagValue: string | boolean | undefined,
): boolean => flagValue === "test";

/**
 * Resolve the dense-mobile modal variant. Development always uses `test` so
 * local work can see the denser SignUp + BecomeAMember layouts without
 * flipping PostHog.
 */
export const resolveSignupModalDenseMobileVariant = (
	flagValue: string | boolean | undefined,
	nodeEnv: string | undefined = process.env.NODE_ENV,
): SignupModalDenseMobileVariant => {
	if (nodeEnv === "development") {
		return "test";
	}

	return isSignupModalDenseMobileTest(flagValue) ? "test" : "control";
};
